import React from "react";
import instantBooking from "../icons/instant-booking.svg";
import { Container, Image } from "./GuaranteedDeparture";

const InstantBooking = props => {
  return (
    <Container title="Instant Booking">
      <Image src={instantBooking} alt="" />
    </Container>
  );
};

export default InstantBooking;
